import { AxiosResponse } from "axios";
import { queryOptions } from "@tanstack/react-query";
import TicketService from "../ticket/ticket.service";
import CustomerAdminService from "./customerAdmin.service";
import { queryClient } from "@/lib/queryClient";



export const createCustomerOptionsQuery = () => queryOptions<any>({
  queryKey: ['customers'],
  queryFn: async ({ signal }) => {
    const ticketService = TicketService();
    return new Promise(async (resolve) => {
      await ticketService
        .getCustomers({
          signal,
          onSuccess: (res: AxiosResponse) => {
            resolve(res.data);
          },
        })
        .then((res) => {
          resolve(res?.data);
        });
    });
  },
  ...queryClient.defaultQueryOptions,
});

export const createCustomerAdminQuery = () => queryOptions<any>({
  queryKey: ['customerAdmin'],
  queryFn: async () => {
    const customerAdminService = CustomerAdminService();
    return new Promise(async (resolve) => {
      await customerAdminService
        .getCustomerAdmin({
          onSuccess: (res: AxiosResponse) => {
            resolve(res.data);
          },
        })
        .then((res) => {
          resolve(res?.data);
        });
    });
  },
  ...queryClient.defaultQueryOptions,
});
